import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowsRepeatCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconArrowsRepeatCircle"><Path d="M11.5 1.5L14.5 4.5L11.5 7.5" stroke="currentColor" strokeLinecap="square"/><Path d="M12.5 16.5L9.5 19.5L12.5 22.5" stroke="currentColor" strokeLinecap="square"/><Path d="M10 19.5H14C18.1421 19.5 21.5 16.1421 21.5 12C21.5 9.5466 20.322 7.36834 18.5007 6" stroke="currentColor" strokeLinecap="square"/><Path d="M14 4.5H10C5.85786 4.5 2.5 7.85786 2.5 12C2.5 14.4534 3.67801 16.6317 5.49927 18" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconArrowsRepeatCircle;
